import { FC, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Box, Fade, Flex } from '@chakra-ui/react';
import { LeaderboardStatPeriod } from 'models';
import checkMeIsEmpty from 'utils/checkMeIsEmpty';
import { createLava } from 'utils/createLavaBubles';
import { getOrdinalSuffix } from 'utils/getOriginalSuffix';

import LeaderboardBanner from './LeaderboardBanner';
import LeaderboardInviteRow from './LeaderboardInviteRow';
import LeaderboardPeriodRow from './LeaderboardPeriodRow';
import NoParticipants from './NoParticipants';

type Props = {
  stat: LeaderboardStatPeriod;

  showLeaderboard?: boolean;
  showMySquad?: boolean;
  showBanner?: boolean;
};

const LeaderboardPeriod: FC<Props> = ({ stat, showLeaderboard = true, showMySquad = true, showBanner = false }) => {
  const [meIsEmpty, setMeIsEmpty] = useState<boolean>(true);
  const [searchParams] = useSearchParams();

  const allUsers = stat.users;
  const friends =
    stat.me && allUsers.length <= 19 ? [...allUsers, stat.me].sort((a, b) => a.place - b.place) : allUsers;
  const users = searchParams.get('friends') === 'true' ? friends : allUsers;

  const [isOpen, setIsOpen] = useState<boolean[]>([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      createLava('bubble');
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (stat.me) {
      setMeIsEmpty(checkMeIsEmpty(stat.me));
    }
  }, [stat.me]);

  // useEffect(() => {
  //   if (users) {
  //     const openBoosters = async () => {
  //       for (let i = 0; i < users.length; i++) {
  //         await new Promise((resolve) => setTimeout(resolve, 50));
  //         setIsOpen((prev) => {
  //           const newIsOpen = [...prev];
  //           newIsOpen[i] = true;
  //           return newIsOpen;
  //         });
  //       }
  //     };
  //     openBoosters();
  //   }
  // }, [users, stat.users]);

  const myPlaceAmongFriends = users.findIndex((u) => u.user.id === stat.me?.user.id) + 1;
  const totalPoints = stat.me?.points === null || stat.me?.points === undefined ? 'TBA' : stat.me?.points;
  const place = searchParams.get('friends') === 'true' ? myPlaceAmongFriends : stat.me?.place;
  const placeString = place ? place.toString() : '0';
  const ordinalSuffix = getOrdinalSuffix(parseInt(placeString));
  const pointsText = `you're #${place} with ${totalPoints}`;
  const text = (() => {
    if (searchParams.get('friends') === 'true') {
      if (users.findIndex((u) => u.user.id === stat.me?.user.id) > -1) {
        return pointsText;
      } else return 'my squad';
    } else if ((searchParams.get('friends') === 'false' && stat.me?.points !== null) || stat.me?.points !== undefined) {
      return pointsText;
    }

    return 'my squad';
  })();

  return (
    <>
      {showBanner && <LeaderboardBanner place={place} totalPoints={totalPoints} users={users} stat={stat} />}
      {(showLeaderboard || showMySquad) && (
        <Flex flexDirection="column" flex="1">
          {!!stat.me && showMySquad && (
            <Box
              w="min-content"
              mx="auto"
              bg="#F83C3C"
              p="8px 12px"
              borderRadius="8px"
              mt="16px"
              mb="8px"
              // boxShadow="0 0 50px 0 rgba(248, 60, 60, 0.25)"
              border="1px solid rgba(255,255,255,0.1)"
              position="relative"
              overflow="hidden"
            >
              <canvas
                id="bubble"
                style={{
                  position: 'absolute',
                  zIndex: 1,
                  top: '-10px',
                  left: '-10px',
                  width: 'calc(100% + 20px)',
                  height: 'calc(100% + 20px)',
                  filter: 'blur(5px)',
                }}
              />
              <Flex align="center" justify="space-between" gap="8px">
                <Flex
                  fontFamily="Special Gothic Expanded One"
                  fontSize="11px"
                  lineHeight="1.3"
                  textTransform="uppercase"
                  fontWeight="400"
                  align="center"
                  gap="7px"
                  whiteSpace="nowrap"
                  zIndex="2"
                >
                  {text}
                </Flex>
              </Flex>
            </Box>
          )}

          {showLeaderboard && (
            <>
              {showLeaderboard && users.length > 0 && (
                <Flex flexDirection="column">
                  {users.map((u, index) => (
                    <Fade key={`${u.user.id}_${index}`} in={true} unmountOnExit>
                      <LeaderboardPeriodRow
                        position={index}
                        participant={u}
                        key={u.user.id}
                        isMe={u.user.id === stat.me?.user.id}
                      />
                    </Fade>
                  ))}
                </Flex>
              )}
              {showLeaderboard && searchParams.get('friends') === 'true' && (
                <Flex flexDirection="column">
                  {Array.from({ length: 2 }).map((_, index) => (
                    <LeaderboardInviteRow key={`invite-row-${index}`} />
                  ))}
                </Flex>
              )}
              {showLeaderboard && users.length <= 0 && (
                <Flex h="100%" flexDirection="column">
                  <NoParticipants nextContest={null} />
                </Flex>
              )}
            </>
          )}
        </Flex>
      )}
    </>
  );
};

export default LeaderboardPeriod;
